import { render } from "./LeftNavigation.vue?vue&type=template&id=1dd4a8c2&scoped=true"
import script from "./LeftNavigation.vue?vue&type=script&lang=js"
export * from "./LeftNavigation.vue?vue&type=script&lang=js"

import "./LeftNavigation.vue?vue&type=style&index=0&id=1dd4a8c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd4a8c2"]])

export default __exports__